module.exports = __webpack_public_path__ + "media/assets/images/flags/dm-cda0c4dc859d8a82a48718924a98dabd.svg";